"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QRCodeModalClassName = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var css_1 = require("@emotion/css");
var react_hook_form_1 = require("react-hook-form");
var recoil_1 = require("recoil");
var dayjs_1 = __importDefault(require("dayjs"));
var components_1 = require("@/components");
var Styled = __importStar(require("./CreateQRCodeModalDialog.styled"));
var time_16_svg_1 = __importDefault(require("@/assets/svg/time-16.svg"));
var utils_1 = require("@/utils");
var store_1 = require("@/store");
var api = __importStar(require("@/api"));
var hooks_1 = require("@/hooks");
exports.QRCodeModalClassName = (0, css_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 38.4rem !important;\n  max-width: 38.4rem !important;\n  h2 {\n    font-size: 24px !important;\n    white-space: pre-wrap !important;\n  }\n"], ["\n  min-width: 38.4rem !important;\n  max-width: 38.4rem !important;\n  h2 {\n    font-size: 24px !important;\n    white-space: pre-wrap !important;\n  }\n"])));
var CreateQRCodeModalDialog = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var scheduleId = _a.scheduleId, eventId = _a.eventId, sessionStartedAt = _a.sessionStartedAt, sessionEndedAt = _a.sessionEndedAt;
    var _h = __read((0, react_2.useState)(false), 2), isLoading = _h[0], setIsLoading = _h[1];
    var handleAddToast = (0, hooks_1.useToast)().handleAddToast;
    var methods = (0, react_hook_form_1.useForm)({ mode: 'onChange' });
    var register = methods.register, handleSubmit = methods.handleSubmit, formState = methods.formState;
    var formValues = methods.getValues();
    var sessionStartTime = (0, dayjs_1.default)(sessionStartedAt).format('HH:mm');
    var sessionEndTime = (0, dayjs_1.default)(sessionEndedAt).format('HH:mm');
    var handleSubmitForm = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set;
        return function (data) { return __awaiter(void 0, void 0, void 0, function () {
            var sessionDate;
            return __generator(this, function (_a) {
                sessionDate = (0, dayjs_1.default)(sessionStartedAt).format('YYYY-MM-DDT');
                (0, utils_1.request)({
                    requestFunc: function () {
                        setIsLoading(true);
                        return api.createQRCode({
                            scheduleId: scheduleId,
                            eventId: eventId,
                            attendanceCheckStartedAt: sessionDate + data.attendanceCheckStartedAt,
                            attendanceCheckEndedAt: sessionDate + data.attendanceCheckEndedAt,
                            latenessCheckEndedAt: sessionDate + data.latenessCheckEndedAt,
                        });
                    },
                    errorHandler: handleAddToast,
                    onSuccess: function (_a) {
                        var qrCodeUrl = _a.data.qrCodeUrl;
                        set((0, store_1.$modalByStorage)(store_1.ModalKey.displayQRCodeModalDialog), {
                            key: store_1.ModalKey.displayQRCodeModalDialog,
                            isOpen: true,
                            props: { qrCodeUrl: qrCodeUrl },
                        });
                    },
                    onCompleted: function () {
                        setIsLoading(false);
                        set((0, store_1.$modalByStorage)(store_1.ModalKey.createQRCodeModalDialog), {
                            key: store_1.ModalKey.createQRCodeModalDialog,
                            isOpen: false,
                        });
                    },
                });
                return [2 /*return*/];
            });
        }); };
    });
    var handleQRCodeModal = (0, recoil_1.useSetRecoilState)((0, store_1.$modalByStorage)(store_1.ModalKey.createQRCodeModalDialog));
    var props = {
        heading: 'QR체크 시간을 입력해주세요',
        footer: {
            cancelButton: {
                label: '취소',
            },
            confirmButton: {
                label: '생성',
                onClick: function () {
                    handleSubmit(handleSubmitForm)();
                },
                type: 'submit',
                isLoading: isLoading,
                disabled: !formValues.attendanceCheckStartedAt ||
                    !formValues.attendanceCheckEndedAt ||
                    !formValues.latenessCheckEndedAt ||
                    !!((_b = formState.errors.attendanceCheckStartedAt) === null || _b === void 0 ? void 0 : _b.message) ||
                    !!((_c = formState.errors.attendanceCheckEndedAt) === null || _c === void 0 ? void 0 : _c.message) ||
                    !!((_d = formState.errors.latenessCheckEndedAt) === null || _d === void 0 ? void 0 : _d.message),
            },
        },
        handleCloseModal: function () {
            handleQRCodeModal({
                key: store_1.ModalKey.createQRCodeModalDialog,
                isOpen: false,
            });
        },
        isContentScroll: false,
    };
    return ((0, jsx_runtime_1.jsx)(components_1.ModalWrapper, __assign({}, props, { className: exports.QRCodeModalClassName, closeButtonHidden: true }, { children: (0, jsx_runtime_1.jsxs)(Styled.Wrapper, { children: [(0, jsx_runtime_1.jsxs)(Styled.QRTimeInputLabel, { children: ["\uCD9C\uC11D \uC2DC\uC791 / \uB9C8\uAC10 \uC2DC\uAC04", (0, jsx_runtime_1.jsx)(Styled.RequiredDot, {}, void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.InputWrapper, { children: [(0, jsx_runtime_1.jsx)(Styled.QRTimeInput, __assign({ "$size": "sm", endIcon: (0, jsx_runtime_1.jsx)(time_16_svg_1.default, {}, void 0), placeholder: sessionStartTime, errorMessage: (_e = formState.errors.attendanceCheckStartedAt) === null || _e === void 0 ? void 0 : _e.message }, register("attendanceCheckStartedAt", {
                            required: true,
                            pattern: {
                                value: utils_1.TIME_REGEX,
                                message: '시간 형식을 확인하세요',
                            },
                        })), void 0), (0, jsx_runtime_1.jsx)(Styled.QRTimeInput, __assign({ "$size": "sm", endIcon: (0, jsx_runtime_1.jsx)(time_16_svg_1.default, {}, void 0), placeholder: sessionEndTime, errorMessage: (_f = formState.errors.attendanceCheckEndedAt) === null || _f === void 0 ? void 0 : _f.message }, register("attendanceCheckEndedAt", {
                            required: true,
                            pattern: {
                                value: utils_1.TIME_REGEX,
                                message: '시간 형식을 확인하세요',
                            },
                        })), void 0)] }, void 0), (0, jsx_runtime_1.jsxs)(Styled.BottomInputWrapper, { children: [(0, jsx_runtime_1.jsxs)(Styled.QRTimeInputLabel, { children: ["\uC9C0\uAC01 \uB9C8\uAC10 \uC2DC\uAC04", (0, jsx_runtime_1.jsx)(Styled.RequiredDot, {}, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(Styled.QRTimeInput, __assign({ "$size": "sm", endIcon: (0, jsx_runtime_1.jsx)(time_16_svg_1.default, {}, void 0), placeholder: sessionStartTime, errorMessage: (_g = formState.errors.latenessCheckEndedAt) === null || _g === void 0 ? void 0 : _g.message }, register("latenessCheckEndedAt", {
                            required: true,
                            pattern: {
                                value: utils_1.TIME_REGEX,
                                message: '시간 형식을 확인하세요',
                            },
                        })), void 0)] }, void 0)] }, void 0) }), void 0));
};
exports.default = CreateQRCodeModalDialog;
var templateObject_1;
